/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clientAddNewClientPost } from '../fn/client/client-add-new-client-post';
import { ClientAddNewClientPost$Params } from '../fn/client/client-add-new-client-post';
import { clientAddNewClientPost$Plain } from '../fn/client/client-add-new-client-post-plain';
import { ClientAddNewClientPost$Plain$Params } from '../fn/client/client-add-new-client-post-plain';
import { clientEditClientPost } from '../fn/client/client-edit-client-post';
import { ClientEditClientPost$Params } from '../fn/client/client-edit-client-post';
import { clientEditClientPost$Plain } from '../fn/client/client-edit-client-post-plain';
import { ClientEditClientPost$Plain$Params } from '../fn/client/client-edit-client-post-plain';
import { clientGetActiveWorkflowsFromHyperScienceGet } from '../fn/client/client-get-active-workflows-from-hyper-science-get';
import { ClientGetActiveWorkflowsFromHyperScienceGet$Params } from '../fn/client/client-get-active-workflows-from-hyper-science-get';
import { clientGetActiveWorkflowsFromHyperScienceGet$Plain } from '../fn/client/client-get-active-workflows-from-hyper-science-get-plain';
import { ClientGetActiveWorkflowsFromHyperScienceGet$Plain$Params } from '../fn/client/client-get-active-workflows-from-hyper-science-get-plain';
import { clientGetAllClientsDataPost } from '../fn/client/client-get-all-clients-data-post';
import { ClientGetAllClientsDataPost$Params } from '../fn/client/client-get-all-clients-data-post';
import { clientGetAllClientsDataPost$Plain } from '../fn/client/client-get-all-clients-data-post-plain';
import { ClientGetAllClientsDataPost$Plain$Params } from '../fn/client/client-get-all-clients-data-post-plain';
import { clientGetClientsGet } from '../fn/client/client-get-clients-get';
import { ClientGetClientsGet$Params } from '../fn/client/client-get-clients-get';
import { clientGetClientsGet$Plain } from '../fn/client/client-get-clients-get-plain';
import { ClientGetClientsGet$Plain$Params } from '../fn/client/client-get-clients-get-plain';
import { clientGetClientTypesGet } from '../fn/client/client-get-client-types-get';
import { ClientGetClientTypesGet$Params } from '../fn/client/client-get-client-types-get';
import { clientGetClientTypesGet$Plain } from '../fn/client/client-get-client-types-get-plain';
import { ClientGetClientTypesGet$Plain$Params } from '../fn/client/client-get-client-types-get-plain';
import { clientGetDivisionsGet } from '../fn/client/client-get-divisions-get';
import { ClientGetDivisionsGet$Params } from '../fn/client/client-get-divisions-get';
import { clientGetDivisionsGet$Plain } from '../fn/client/client-get-divisions-get-plain';
import { ClientGetDivisionsGet$Plain$Params } from '../fn/client/client-get-divisions-get-plain';
import { clientGetLayoutFieldsGet } from '../fn/client/client-get-layout-fields-get';
import { ClientGetLayoutFieldsGet$Params } from '../fn/client/client-get-layout-fields-get';
import { clientGetLayoutFieldsGet$Plain } from '../fn/client/client-get-layout-fields-get-plain';
import { ClientGetLayoutFieldsGet$Plain$Params } from '../fn/client/client-get-layout-fields-get-plain';
import { clientGetTimeZonesTimezonesGet } from '../fn/client/client-get-time-zones-timezones-get';
import { ClientGetTimeZonesTimezonesGet$Params } from '../fn/client/client-get-time-zones-timezones-get';
import { clientGetWorkflowReleaseLayoutsGet } from '../fn/client/client-get-workflow-release-layouts-get';
import { ClientGetWorkflowReleaseLayoutsGet$Params } from '../fn/client/client-get-workflow-release-layouts-get';
import { clientGetWorkflowReleaseLayoutsGet$Plain } from '../fn/client/client-get-workflow-release-layouts-get-plain';
import { ClientGetWorkflowReleaseLayoutsGet$Plain$Params } from '../fn/client/client-get-workflow-release-layouts-get-plain';
import { GeneralResponse } from '../models/general-response';
import { GetClientsResponseDto } from '../models/get-clients-response-dto';
import { LayoutFieldsResponseDto } from '../models/layout-fields-response-dto';
import { WorkflowReleaseLayouts } from '../models/workflow-release-layouts';
import { WorkflowsResponseDto } from '../models/workflows-response-dto';

@Injectable({ providedIn: 'root' })
export class ClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientGetAllClientsDataPost()` */
  static readonly ClientGetAllClientsDataPostPath = '/Client/GetAllClientsData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetAllClientsDataPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientGetAllClientsDataPost$Plain$Response(params?: ClientGetAllClientsDataPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GetClientsResponseDto>>> {
    return clientGetAllClientsDataPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetAllClientsDataPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientGetAllClientsDataPost$Plain(params?: ClientGetAllClientsDataPost$Plain$Params, context?: HttpContext): Observable<Array<GetClientsResponseDto>> {
    return this.clientGetAllClientsDataPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GetClientsResponseDto>>): Array<GetClientsResponseDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetAllClientsDataPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientGetAllClientsDataPost$Response(params?: ClientGetAllClientsDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GetClientsResponseDto>>> {
    return clientGetAllClientsDataPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetAllClientsDataPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientGetAllClientsDataPost(params?: ClientGetAllClientsDataPost$Params, context?: HttpContext): Observable<Array<GetClientsResponseDto>> {
    return this.clientGetAllClientsDataPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GetClientsResponseDto>>): Array<GetClientsResponseDto> => r.body)
    );
  }

  /** Path part for operation `clientAddNewClientPost()` */
  static readonly ClientAddNewClientPostPath = '/Client/AddNewClient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientAddNewClientPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientAddNewClientPost$Plain$Response(params?: ClientAddNewClientPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientAddNewClientPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientAddNewClientPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientAddNewClientPost$Plain(params?: ClientAddNewClientPost$Plain$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientAddNewClientPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientAddNewClientPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientAddNewClientPost$Response(params?: ClientAddNewClientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientAddNewClientPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientAddNewClientPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientAddNewClientPost(params?: ClientAddNewClientPost$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientAddNewClientPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /** Path part for operation `clientEditClientPost()` */
  static readonly ClientEditClientPostPath = '/Client/EditClient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientEditClientPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientEditClientPost$Plain$Response(params?: ClientEditClientPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientEditClientPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientEditClientPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientEditClientPost$Plain(params?: ClientEditClientPost$Plain$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientEditClientPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientEditClientPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientEditClientPost$Response(params?: ClientEditClientPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
    return clientEditClientPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientEditClientPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientEditClientPost(params?: ClientEditClientPost$Params, context?: HttpContext): Observable<GeneralResponse> {
    return this.clientEditClientPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneralResponse>): GeneralResponse => r.body)
    );
  }

  /** Path part for operation `clientGetClientsGet()` */
  static readonly ClientGetClientsGetPath = '/Client/GetClients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientsGet$Plain$Response(params?: ClientGetClientsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientGetClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientsGet$Plain(params?: ClientGetClientsGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientGetClientsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetClientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientsGet$Response(params?: ClientGetClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientGetClientsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetClientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientsGet(params?: ClientGetClientsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientGetClientsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `clientGetDivisionsGet()` */
  static readonly ClientGetDivisionsGetPath = '/Client/GetDivisions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetDivisionsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetDivisionsGet$Plain$Response(params?: ClientGetDivisionsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientGetDivisionsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetDivisionsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetDivisionsGet$Plain(params?: ClientGetDivisionsGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientGetDivisionsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetDivisionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetDivisionsGet$Response(params?: ClientGetDivisionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientGetDivisionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetDivisionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetDivisionsGet(params?: ClientGetDivisionsGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientGetDivisionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `clientGetClientTypesGet()` */
  static readonly ClientGetClientTypesGetPath = '/Client/GetClientTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetClientTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientTypesGet$Plain$Response(params?: ClientGetClientTypesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientGetClientTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetClientTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientTypesGet$Plain(params?: ClientGetClientTypesGet$Plain$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientGetClientTypesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetClientTypesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientTypesGet$Response(params?: ClientGetClientTypesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return clientGetClientTypesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetClientTypesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetClientTypesGet(params?: ClientGetClientTypesGet$Params, context?: HttpContext): Observable<Array<string>> {
    return this.clientGetClientTypesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `clientGetTimeZonesTimezonesGet()` */
  static readonly ClientGetTimeZonesTimezonesGetPath = '/Client/GetTimeZones/timezones';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetTimeZonesTimezonesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetTimeZonesTimezonesGet$Response(params?: ClientGetTimeZonesTimezonesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return clientGetTimeZonesTimezonesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetTimeZonesTimezonesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetTimeZonesTimezonesGet(params?: ClientGetTimeZonesTimezonesGet$Params, context?: HttpContext): Observable<void> {
    return this.clientGetTimeZonesTimezonesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `clientGetActiveWorkflowsFromHyperScienceGet()` */
  static readonly ClientGetActiveWorkflowsFromHyperScienceGetPath = '/Client/GetActiveWorkflowsFromHyperScience';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetActiveWorkflowsFromHyperScienceGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetActiveWorkflowsFromHyperScienceGet$Plain$Response(params?: ClientGetActiveWorkflowsFromHyperScienceGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowsResponseDto>>> {
    return clientGetActiveWorkflowsFromHyperScienceGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetActiveWorkflowsFromHyperScienceGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetActiveWorkflowsFromHyperScienceGet$Plain(params?: ClientGetActiveWorkflowsFromHyperScienceGet$Plain$Params, context?: HttpContext): Observable<Array<WorkflowsResponseDto>> {
    return this.clientGetActiveWorkflowsFromHyperScienceGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkflowsResponseDto>>): Array<WorkflowsResponseDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetActiveWorkflowsFromHyperScienceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetActiveWorkflowsFromHyperScienceGet$Response(params?: ClientGetActiveWorkflowsFromHyperScienceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowsResponseDto>>> {
    return clientGetActiveWorkflowsFromHyperScienceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetActiveWorkflowsFromHyperScienceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetActiveWorkflowsFromHyperScienceGet(params?: ClientGetActiveWorkflowsFromHyperScienceGet$Params, context?: HttpContext): Observable<Array<WorkflowsResponseDto>> {
    return this.clientGetActiveWorkflowsFromHyperScienceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkflowsResponseDto>>): Array<WorkflowsResponseDto> => r.body)
    );
  }

  /** Path part for operation `clientGetWorkflowReleaseLayoutsGet()` */
  static readonly ClientGetWorkflowReleaseLayoutsGetPath = '/Client/GetWorkflowReleaseLayouts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetWorkflowReleaseLayoutsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetWorkflowReleaseLayoutsGet$Plain$Response(params?: ClientGetWorkflowReleaseLayoutsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowReleaseLayouts>>> {
    return clientGetWorkflowReleaseLayoutsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetWorkflowReleaseLayoutsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetWorkflowReleaseLayoutsGet$Plain(params?: ClientGetWorkflowReleaseLayoutsGet$Plain$Params, context?: HttpContext): Observable<Array<WorkflowReleaseLayouts>> {
    return this.clientGetWorkflowReleaseLayoutsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkflowReleaseLayouts>>): Array<WorkflowReleaseLayouts> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetWorkflowReleaseLayoutsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetWorkflowReleaseLayoutsGet$Response(params?: ClientGetWorkflowReleaseLayoutsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowReleaseLayouts>>> {
    return clientGetWorkflowReleaseLayoutsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetWorkflowReleaseLayoutsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetWorkflowReleaseLayoutsGet(params?: ClientGetWorkflowReleaseLayoutsGet$Params, context?: HttpContext): Observable<Array<WorkflowReleaseLayouts>> {
    return this.clientGetWorkflowReleaseLayoutsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkflowReleaseLayouts>>): Array<WorkflowReleaseLayouts> => r.body)
    );
  }

  /** Path part for operation `clientGetLayoutFieldsGet()` */
  static readonly ClientGetLayoutFieldsGetPath = '/Client/GetLayoutFields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetLayoutFieldsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetLayoutFieldsGet$Plain$Response(params?: ClientGetLayoutFieldsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LayoutFieldsResponseDto>>> {
    return clientGetLayoutFieldsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetLayoutFieldsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetLayoutFieldsGet$Plain(params?: ClientGetLayoutFieldsGet$Plain$Params, context?: HttpContext): Observable<Array<LayoutFieldsResponseDto>> {
    return this.clientGetLayoutFieldsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LayoutFieldsResponseDto>>): Array<LayoutFieldsResponseDto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientGetLayoutFieldsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetLayoutFieldsGet$Response(params?: ClientGetLayoutFieldsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LayoutFieldsResponseDto>>> {
    return clientGetLayoutFieldsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientGetLayoutFieldsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientGetLayoutFieldsGet(params?: ClientGetLayoutFieldsGet$Params, context?: HttpContext): Observable<Array<LayoutFieldsResponseDto>> {
    return this.clientGetLayoutFieldsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LayoutFieldsResponseDto>>): Array<LayoutFieldsResponseDto> => r.body)
    );
  }

}
